import { canUseRasterSurfaceBudgetWithExtraBytes } from "../layers/layerMemory";
import { RASTER_STORE_MEMORY_BUDGET_BYTES } from "../layers/layerTypes";

export const MAX_FILL_CLIP_PIXELS = 3_200_000;
export const MAX_FILL_RGBA_WORKING_BYTES = MAX_FILL_CLIP_PIXELS * 4;
export const MAX_FILL_VISITED_BYTES = Math.ceil(MAX_FILL_CLIP_PIXELS / 8);
export const MAX_FILL_QUEUE_ENTRIES = 1_000_000;
export const MAX_FILL_QUEUE_BYTES = MAX_FILL_QUEUE_ENTRIES * 4;
export const FILL_HISTORY_COMMAND_ESTIMATE_BYTES = 320;
export const MAX_FILL_SIMULTANEOUS_WORKING_BYTES =
  MAX_FILL_RGBA_WORKING_BYTES + MAX_FILL_VISITED_BYTES + MAX_FILL_QUEUE_BYTES;

export function fillWorkingBytes(pixelCount: number): number {
  if (!Number.isSafeInteger(pixelCount) || pixelCount < 1 || pixelCount > MAX_FILL_CLIP_PIXELS) {
    return Number.POSITIVE_INFINITY;
  }
  return (
    pixelCount * 4 + Math.ceil(pixelCount / 8) + Math.min(pixelCount, MAX_FILL_QUEUE_ENTRIES) * 4
  );
}

export function canApplyBoundedFill(
  width: number,
  height: number,
  persistentSurfaceCount: number,
  targetAlreadyAllocated: boolean,
  clipPixelCount: number,
  budget = RASTER_STORE_MEMORY_BUDGET_BYTES,
): boolean {
  const workingBytes = fillWorkingBytes(clipPixelCount);
  if (!Number.isFinite(workingBytes)) return false;
  return canUseRasterSurfaceBudgetWithExtraBytes(
    width,
    height,
    persistentSurfaceCount + (targetAlreadyAllocated ? 0 : 1),
    0,
    workingBytes,
    budget,
  );
}
